module.exports = __webpack_public_path__ + "img/travel-insurance-banner.cb53977f.jpg";